import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

type NumberFieldProps = TextFieldProps & {
  validateIsNotEmpty?: boolean | undefined;
  steps?: number;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function NumberField(props: NumberFieldProps) {
  const { validateIsNotEmpty = false, steps, handleChange, handleBlur, ...rest } = props;

  return (
    <MuiTextField
      variant='standard'
      type='number'
      fullWidth
      InputLabelProps={{
        shrink: true,
      }}
      required={validateIsNotEmpty || false}
      onChange={(event) => {
        const value = event.target.value.replace(',', '.');
        handleChange(parseFloat(value));
      }}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
        min: 0,
        step: steps != null ? steps : 1,
      }}
      {...rest}
    />
  );
}

export type { NumberFieldProps };

export default NumberField;
